import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';

import { AppInitStatus } from '../enums/app-init-status';
import { AuthService } from './auth.service';

declare global {
  interface Window {
    appConfig: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  private _observers: Subscription = new Subscription();
  private _status = new BehaviorSubject(AppInitStatus.LOAD);

  get status(): Observable<AppInitStatus> {
    return this._status.asObservable();
  }

  constructor(
    private authService: AuthService
  ) {
    this.setObservers();
  }

  /**
   * Sets observers
   */
  private setObservers(): void {
    this._observers.add(this.initObserver());
  }

  /**
   * Changes app initialization status
   * @param status
   */
  public changeAppInitStatus(status: AppInitStatus): void {
    this._status.next(status);
  }

  /**
   * Checks some app features to finish app initialization
   * @returns Subscription
   */
  public initObserver(): Subscription {
    return this.authService.isAuthenticated.subscribe((res: boolean) => {
      this.changeAppInitStatus(AppInitStatus.DONE);
    });
  }
}
